// extracted by mini-css-extract-plugin
export default {"LandingPage":"landingPageSpinner_LandingPage__TkXDj"};